<template>
  <main>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="search"
                          :placeholder="$t('keyword')"></b-form-input>
            <time-range-picker :model="filterFormModel" :label="$t('createTime')" class="mr-1 mb-1"></time-range-picker>
            <button @click="search" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting" v-if="['owner'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-4">{{ $t('info') }}</div>
            <div class="col-lg-2 text-center">{{ $t('eSignPrice') }}</div>
            <div class="col-lg-2 text-center">{{ $t('invoicePrice') }}</div>
            <div class="col-lg-2">{{ $t('time') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-4">
              <div>
                <b>{{ $t('name') }}: </b>
                <span v-if="item.name">{{ item.name }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('code') }}: </b>
                <span v-if="item.code">{{ item.code }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('desc') }}: </b>
                <span v-if="item.desc">{{ item.desc }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div v-if="item.default">
                <span class="badge badge-primary">{{ $t('default') }}</span>
              </div>
            </div>
            <div class="col-lg-2 text-center">{{ (item.esignPrice || 0) | numFormat }}</div>
            <div class="col-lg-2 text-center">{{ (item.invoicePrice || 0) | numFormat }}</div>
            <div class="col-lg-2">
              <div>
                <b>{{ $t('createTime') }}: </b>
                <span v-if="item.createTime">{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('updateTime') }}: </b>
                <span v-if="item.updateTime">{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
            </div>
            <div class="col-lg-2 text-right">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col" v-if="['owner'].includes($store.state.user.role)">
                    <button @click="update(item._id)" type="button" class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button"
                            v-if="['owner'].includes($store.state.user.role)"
                            class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>

      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" size="lg" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
      <form-input :disabled="formModel.id" :label="$t('code')" :model="formModel" attribute="code"
                  :errors="formErrors"></form-input>
      <form-textarea row="3" :label="$t('desc')" :model="formModel" attribute="desc"
                     :errors="formErrors"></form-textarea>
      <form-input :label="$t('eSignPrice')" :model="formModel" attribute="esignPrice"
                  type="number" :errors="formErrors"></form-input>
      <form-input :label="$t('invoicePrice')" :model="formModel" attribute="invoicePrice"
                  type="number" :errors="formErrors"></form-input>
      <form-checkbox :chk-label="$t('default')" :model="formModel" attribute="default"
                     :errors="formErrors"></form-checkbox>
    </b-modal>
  </main>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import Utils from '../../utils';
import TimeRangePicker from "@/components/TimeRangePicker.vue";

export default {
  components: {TimeRangePicker},
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/invoice-gateway',
      autoLoad: true,
      defaultFilterFormModel: {
        keyword: null
      },
      defaultFormModel: {
        name: null,
        code: null,
        desc: null,
        esignPrice: 0,
        invoicePrice: 0,
        default: false
      },
    }
  },
  i18n: {
    messages: {
      en: {
        code: 'Code',
        eSignPrice: 'Minimum price for digital signature (VND)',
        invoicePrice: 'Minimum package price / invoice (VND)',
        default: 'Default'
      },
      vi: {
        code: 'Mã',
        eSignPrice: 'Giá tối thiểu chữ ký số (VND)',
        invoicePrice: 'Giá gói tối thiểu / hóa đơn (VND)',
        default: 'Mặc định'
      }
    }
  },
  watch: {
    "formModel.name": {
      handler(val) {
        if (!this.formModel.id) {
          if (val) {
            this.formModel.code = Utils.methods.createAlias(val);
          }
        }
      }
    },
  },
  methods: {
    search() {
      this.filterFormModel.page = 1;
      this.load()
    },
    load: function () {
      let loader = this.$loading.show();
      this.loading = true;
      this.listLoading = true;
      this.$service.get(this.service, {
        params: this.filterFormModel
      }).then(response => {
        this.apply(response.data);
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        }
      }).finally(() => {
        loader.hide();
        this.loading = false;
        this.listLoading = false;
        if (this.afterLoad) {
          this.afterLoad();
        }
      });
    }
  }
};
</script>